export enum ELanguages {
  fr,
}
